import React, { useState } from 'react';
import { Label, Wrapper } from './FileSelector.styles';
import { ApSimpleDropdown } from '@alixpartners/ui-components';

const FileSelector = ({
	filterData,
	setSelectedFile,
	setSelectedSheet,
	setSheetOption,
}) => {
	const [option, setOption] = useState({});

	const onFileSelectionHandler = value => {
		const file = filterData?.excels.find(
			file => file.excelName === value.value
		);
		setOption(value);
		setSelectedFile(file);
		setSelectedSheet(null);
		setSheetOption(null);
	};

	return (
		<Wrapper>
			<Label>Select File:</Label>
			<ApSimpleDropdown
				onChange={onFileSelectionHandler}
				options={filterData?.excels?.map(file => {
					return { label: file?.excelName, value: file?.excelName };
				})}
				selected={option}
			/>
		</Wrapper>
	);
};

export default FileSelector;
